import React, { useEffect, useState } from "react";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader.jsx";
import { BeforeLoginHeader } from "../../../stories/BeforeLoginHeader/BeforeLoginHeader.jsx";
import { Radio } from "../../../stories/Radio/Radio";
import { Input } from "../../../stories/Input/Input.jsx";
import { Footer } from "../../../stories/Footer/Footer.jsx";
import { Row, Col } from "react-bootstrap";
import classes from "./Help.module.css";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import {
  HeadingBg,
  CapIconRed,
  HelpStarIcon,
  StarIconOrange,
} from "../../../constant/imagePath";
import { Button } from "../../../stories/Button/Button.jsx";
import { CommonQuestions } from "../../../stories/CommonQuestions/CommonQuestions";
import { HelpSearch } from "../../../stories/HelpSearch/HelpSearch";
import HelpMobile from "./HelpMobile.jsx";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook.js";
import useDebounce from "../../../CustomHooks/useDebounce.jsx";
import commonQuesCss from "../../../stories/CommonQuestions/commonQuestions.module.css";

const cards = [
  {
    title: "Students",
    icon: CapIconRed,
    description:
      "Find out more about the student's profile and all the nuances of booking a lesson.",
  },
  {
    title: "Coaches",
    icon: HelpStarIcon,
    description:
      "Learn all about registration, profile management and other features.",
  },
];

const HelpDesktop = () => {
  const [search, setSearch] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [searchArray, setSearchArray] = useState([]);

  const staticSearchArray = [
    {
      title: "Coaches",
      categories: [
        {
          title: "How does LyteSnap work?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "How do I become a LyteSnap Coach?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "Keys for an outstanding coach application",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "Am I eligible to be a LyteSnap Coach?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
      ],
    },
    {
      title: "Students",
      categories: [
        {
          title: "How do I find a coach and get started?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "How much does it cost to book training sessions?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "How can I reset my password or email?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
      ],
    },
  ];

  // On Search
  function onSubmitSearch({ searchValue }) {
    setSearch(searchValue);
  }

  useEffect(() => {
    if (search !== null) {
      const roleIndex = staticSearchArray.findIndex((item) =>
        item?.title?.includes(selectedRole)
      );
      const searchObject = staticSearchArray[roleIndex]?.categories.find(
        (item) => item?.title?.includes(search)
      );
      console.log({ searchObject, roleIndex });
      setSearchArray([
        {
          title: selectedRole,
          categories: [searchObject],
        },
      ]);
    } else {
      setSearchArray(staticSearchArray);
    }
  }, [search]);

  console.log({ selectedRole, searchArray });

  return (
    <div className={classes.helpPage}>
      <style jsx>{`
        .${commonQuesCss.commonQuestions} h4 {
          margin-bottom: 32px;
        }
      `}</style>
      <div className="container-fluid" style={{ padding: "0px" }}>
        <Row style={{ minHeight: "100vh" }}>
          <div className={classes.header}>
            <AfterLoginHeader />
          </div>

          <Col md={12}>
            <Row
              className={classes.howCanWeHelp}
              style={{ backgroundColor: Colors.neutralShadesOfWhiteSmoke }}
            >
              <Col md={12}>
                <h2 style={{ ...Fonts.h2, color: Colors.neutralShadesOfNero }}>
                  How can we help?
                  <img src={HeadingBg} />
                </h2>
              </Col>
              <Col md={12}>
                <div className={classes.searchBox}>
                  <HelpSearch
                    placeholder={"Search Lytesnap help center"}
                    setter={setSearch}
                    searchArray={staticSearchArray}
                    onSubmitSearch={onSubmitSearch}
                    setSelectedRole={setSelectedRole}
                  />
                </div>
              </Col>
            </Row>
          </Col>
          {/* Main Content */}
          <Col md={12} className={classes.mainContent}>
            <Row style={{ width: "100%" }}>
              {selectedRole === null ? (
                cards?.map((item) => {
                  return (
                    <Col md={6} sm={12}>
                      <div
                        className={classes.card}
                        style={{
                          border: `1px solid ${Colors.neutralShadesOfWhisper}`,
                        }}
                        onClick={() => {
                          setSelectedRole(item?.title);
                        }}
                      >
                        <div className={classes.cardIcon}>
                          <img src={item?.icon} />
                        </div>
                        <h5
                          style={{
                            ...Fonts.h5,
                            color: Colors.neutralShadesOfNero,
                          }}
                        >
                          {item?.title}
                        </h5>
                        <p
                          style={{
                            ...Fonts.p1,
                            color: Colors.neutralShadesOfDimGray,
                          }}
                        >
                          {item?.description}
                        </p>
                      </div>
                    </Col>
                  );
                })
              ) : (
                <Col md={12}>
                  {/* Breadcrumb */}
                  <p
                    className={classes.breadcrumb}
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    Lytesnap Help Center
                    {selectedRole && ` / ${selectedRole}`}{" "}
                    {search && ` / ${search}`}
                  </p>
                  {searchArray?.map((item, index) => {
                    return (
                      <>
                        {(selectedRole === item?.title || !selectedRole) && (
                          <div className={classes.mb32}>
                            <CommonQuestions
                              heading={item?.title}
                              data={item?.categories}
                            />
                          </div>
                        )}
                      </>
                    );
                  })}

                  {search == null && selectedRole && (
                    <div className={classes.mt32}>
                      <CommonQuestions
                        heading="Managing My Account"
                        data={[
                          {
                            title: "How do I set my availability?",
                            description:
                              "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
                          },
                          {
                            title:
                              "Why might my background check not be verified?",
                            description:
                              "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
                          },
                        ]}
                      />
                    </div>
                  )}
                </Col>
              )}
            </Row>
          </Col>
          <Col md={12} style={{ alignSelf: "flex-end" }}>
            <Footer className={classes.container} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

function Help() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, [window.innerWidth]);

  return <div>{isMobile ? <HelpMobile /> : <HelpDesktop />}</div>;
}

export default Help;
